import { FC } from 'react';
import { TableBody, TableCell, TableRow } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

import { Ventilasjon } from '../../../../../types/registration/userInput';
import {
  LeftBorderCell,
  StyledTable
} from '../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';

interface VentilasjonProps {
  data: Ventilasjon;
}
export const VentilasjonView: FC<VentilasjonProps> = ({ data }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.ventilasjon' });
  const { t: tVentilasjonstyper } = useTranslation('', { keyPrefix: 'form.ventilasjon.options' });
  const { t: tCommon } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.common' });
  const hasVentilasjon = !!(
    data.gjenvinningAvVarme ||
    data.serviceGjennomfortSiste2Ar ||
    data.ventilasjonType ||
    data.gjenvinningsType ||
    data.installasjonsAr
  );

  return (
    hasVentilasjon && (
      <StyledTable>
        <TableBody>
          {data.ventilasjonType && (
            <TableRow>
              <TableCell>{t('type')}</TableCell>
              <LeftBorderCell>{tVentilasjonstyper(`${data.ventilasjonType}.label`)}</LeftBorderCell>
            </TableRow>
          )}
          {data.installasjonsAr && (
            <TableRow>
              <TableCell>{t('installasjonsar')}</TableCell>
              <LeftBorderCell>{data.vetInstallasjonsAr ? data.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: data.installasjonsAr })}</LeftBorderCell>
            </TableRow>
          )}
          {data.serviceGjennomfortSiste2Ar && (
            <TableRow>
              <TableCell>{t('serviceGjennomfortSiste2Ar')}</TableCell>
              <LeftBorderCell> {t(`${data.serviceGjennomfortSiste2Ar}`)}</LeftBorderCell>
            </TableRow>
          )}
          {data.gjenvinningAvVarme && (
            <TableRow>
              <TableCell>{t('varmegjenvinning.label')}</TableCell>
              <LeftBorderCell> {t(`${data.gjenvinningAvVarme}`)}</LeftBorderCell>
            </TableRow>
          ) &&
            data.gjenvinningsType && (
              <TableRow>
                <TableCell>{t('varmegjenvinning.type')}</TableCell>
                <LeftBorderCell> {t(`${data.gjenvinningsType}`)}</LeftBorderCell>
              </TableRow>
            )}
        </TableBody>
      </StyledTable>
    )
  );
};
